import { jsx as o, Fragment as r } from "react/jsx-runtime";

import { times as t } from "../utils/index.js";

import e from "../hooks/useGlobals.js";

const s = () => {
    const {components: s} = e();
    return o(r, {
        children: t(6, (r => o("tr", {
            children: t(7, (t => o(s.DayCell, {
                dayIndex: 7 * r + t
            }, t)))
        }, r)))
    });
};

export { s as default };
//# sourceMappingURL=DaysTableBodyRows.js.map
